import { goal as goalConfig, propertyOption as propertyOptionConfig } from 'shared/api/query/configs.json';

export const requiredDirectPropertiesMap = {
  [goalConfig.edges.description]: propertyOptionConfig.edges.descriptionRequired,
  [goalConfig.edges.goalCycle]: propertyOptionConfig.edges.cycleRequired,
  [goalConfig.edges.parents]: propertyOptionConfig.edges.parentRequired,
};
